import React, {Component} from 'react';
import { FormGroup, Label, Input } from 'reactstrap';

class PriceInput extends Component {

    state = {
        value: ''
    }

    componentDidMount = () => {

        this.setState({
            value: this.props.value
        })

    }

    handleInputChange = (e) => {

        if (this.props.type !== 'select') {
            this.props.onChange(this.props.field, e.target.value);
        }

    }

    handleSelectChange = (e) => {

        if (this.props.type === 'select') {
            this.props.onChange(this.props.field, e.target.value);
        }

    }

    render() {

        return (
            <FormGroup>
                <Label for={this.props.field}>{this.props.name}</Label>
                <Input onChange={this.handleSelectChange} onBlur={this.handleInputChange} defaultValue={this.state.value} type={this.props.type} name={this.props.field} id={this.props.field} placeholder={this.props.name}>
                    {this.props.children}
                </Input>
            </FormGroup>
        );
    }

}

export default PriceInput;



// WEBPACK FOOTER //
// ./src/components/PriceInput.js